const SERVICE_DATA = [
  {
    imageUrl: 'https://img.freepik.com/free-vector/web-development-programmer-engineering-coding-website-augmented-reality-interface-screens-developer-project-engineer-programming-software-application-design-cartoon-illustration_107791-3863.jpg?w=2000&t=st=1704730772~exp=1704731372~hmac=f7123cad6d7c75208073251c2676307ea3ec05e009a5e31bf99a61798e40d647',
    technologyName: 'Web Development',
    description: 'Web Development with React.js, Node.js, JavaScript, HTML, CSS, TailwindCss, Express.js, Php, Python, BaseWeb, SQL Database, MongoDB And All Other technologies',
  },
  {
    imageUrl: 'https://assets-global.website-files.com/6410ebf8e483b5bb2c86eb27/6410ebf8e483b5758186fbd8_ABM%20college%20mobile%20app%20dev%20main.jpg',
    technologyName: 'App Development',
    description: 'App Development with React Native, Node.js, JavaScript, TailwindCss, Express.js, MongoDB And All Other technologies',
  }
];

export { SERVICE_DATA }